import { useCallback, useState } from 'react';
import { Icon } from './Icon.js';

export interface IdMonoProps {
  readonly value: string;
  /** What to show on screen (defaults to truncated value). */
  readonly display?: string;
  /** Hide the copy icon (no clipboard write either). */
  readonly noCopy?: boolean;
  readonly title?: string;
  readonly testId?: string;
}

function defaultDisplay(value: string): string {
  if (value.length <= 14) return value;
  return `${value.slice(0, 6)}…${value.slice(-4)}`;
}

export function IdMono({ value, display, noCopy, title, testId }: IdMonoProps): JSX.Element {
  const [copied, setCopied] = useState(false);

  const onCopy = useCallback(async () => {
    if (noCopy) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard rejected — silent; user can still select+copy manually */
    }
  }, [value, noCopy]);

  return (
    <span
      className="id-mono"
      role={noCopy ? undefined : 'button'}
      title={title ?? value}
      onClick={onCopy}
      data-testid={testId}
    >
      <span>{display ?? defaultDisplay(value)}</span>
      {noCopy ? null : copied ? <Icon.Check size={11} /> : <Icon.Copy size={11} />}
    </span>
  );
}
